import { FormattedHTMLMessage } from "react-intl";

import { useMessage } from "@/components/Message";
import { FormFieldText } from "@/components/FormFields/FormFieldText/FormFieldText";
import { getFieldConfigByFieldId } from "@/lib/utils/stepComponentHelpers/stepComponentHelpers";
import { type FormFieldComponentProps } from "@/lib/types/types";

export const FirstNameComponent = ({
  value,
  isErrored,
  onChange,
  placeholder = "",
  disabled = false,
}: FormFieldComponentProps) => {
  const { msg } = useMessage();
  const isFieldHidden = getFieldConfigByFieldId("firstName")?.hidden;

  if (isFieldHidden) {
    return null;
  }

  return (
    <FormFieldText
      fieldId="firstName"
      autoComplete="given-name"
      value={value}
      onChange={onChange}
      placeholder={placeholder || msg({ id: "firstNamePlaceholder" })}
      label={<FormattedHTMLMessage id="firstName" defaultMessage="First name" />}
      errorMessage={
        isErrored && (
          <FormattedHTMLMessage id="errorId.invalidFirstName" defaultMessage="Invalid first name" />
        )
      }
      showPlaceholderAndHideLabel={!!placeholder}
      disabled={disabled}
    />
  );
};
